import { endpoints } from 'services/endpoints';
import request from 'services/request';
import { paramsToFormData } from 'utils/utils';

export default {
  postCompanyCodeList: (params: CompanyCodeListReqDto): Promise<CompanyCodeListResDto> =>
    request({
      url: endpoints.company.code,
      method: 'post',
      data: paramsToFormData(params),
    }),  
  postCompanyList: (params: CompanyListReqDto): Promise<CompanyListResDto> =>
    request({
      url: endpoints.company.list,
      method: 'post',
      data: paramsToFormData(params),
    }),
  postCompanyInfo: (params: CommonIdReqDto): Promise<CompanyInfoResDto> =>
    request({
      url: endpoints.company.info,
      method: 'post',
      data: paramsToFormData(params),
    }),    
  postCompanyAdd: (params: CompanySaveReqDto): Promise<CommonInsertResDto> =>
    request({
      url: endpoints.company.add,
      method: 'post',
      data: paramsToFormData(params),
    }),
  postCompanyMatchAdd: (params: CompanySaveReqDto): Promise<CommonInsertResDto> =>
    request({
      url: endpoints.company.match_add,
      method: 'post',
      data: paramsToFormData(params),
    }),
  postCompanyBusinessFileIdUpdate: (params: CompanySaveReqDto): Promise<CommonResDto> =>
    request({
      url: endpoints.company.business_update,
      method: 'post',
      data: paramsToFormData(params),
    }),     
  postCompanyUpdate: (params: CompanySaveReqDto): Promise<CommonResDto> =>
    request({
      url: endpoints.company.update,
      method: 'post',
      data: paramsToFormData(params),
    }),
  postCompanyFileUpdate: (params: CompanySaveReqDto): Promise<CommonResDto> =>
    request({
      url: endpoints.company.filesave,
      method: 'post',
      data: paramsToFormData(params),
    }),  
  postCompanyMoneyList: (params: CompanyCashListReqDto): Promise<CompanyCashListResDto> =>
    request({
      url: endpoints.company.money.list,
      method: 'post',
      data: paramsToFormData(params),
    }),
  postCompanyMoneyAdd: (params: CompanyCashSaveReqDto): Promise<CommonInsertResDto> =>
    request({
      url: endpoints.company.money.add,
      method: 'post',
      data: paramsToFormData(params),
    }),    
  postCompanyPointList: (params: CompanyCashListReqDto): Promise<CompanyCashListResDto> =>
    request({
      url: endpoints.company.point.list,
      method: 'post',
      data: paramsToFormData(params),
    }),
  postCompanyPointAdd: (params: CompanyCashSaveReqDto): Promise<CommonInsertResDto> =>
    request({
      url: endpoints.company.point.add,
      method: 'post',
      data: paramsToFormData(params),
    }),    
};
